import { Helmet } from 'react-helmet-async';

const SITE = 'https://barcabrero.com';
const DEFAULT_OG = `${SITE}/og-image.jpg`;

/**
 * Per-page SEO helper.
 *
 * Pass `schema` (single object) or `schemas` (array) to inject additional
 * JSON-LD structured data on a specific page (e.g. AboutPage, ContactPage,
 * BreadcrumbList). The global BarOrPub / Menu / FAQ schemas in index.html
 * remain unchanged.
 */
export default function Seo({
  title,
  description,
  path = '/',
  image = DEFAULT_OG,
  schema,
  schemas,
}) {
  const fullTitle = title ? `${title} — Bar Cabrero` : 'Bar Cabrero — Gildas Artesanas en Torrelavega desde 1928';
  const url = `${SITE}${path}`;
  const allSchemas = [
    ...(schemas || []),
    ...(schema ? [schema] : []),
  ];
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta property="og:locale" content="es_ES" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      {allSchemas.map((s, i) => (
        <script key={i} type="application/ld+json">
          {JSON.stringify(s)}
        </script>
      ))}
    </Helmet>
  );
}
